import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "reactstrap";
import classnames from "classnames";
import { ChevronRight } from "react-feather";

const isItemTypeOfNode = ({ children } = {}) =>
  Array.isArray(children) && !!children?.length;

class SideMenuGroup extends React.Component {
  constructor(props) {
    super(props);
    this.flag = true;
    this.parentArray = [];
    this.childObj = {};
  }
  state = {
    isOpen: false,
    activeItem: this.props.activePath,
  };

  handleActiveItem = (url) => {
    this.setState({
      activeItem: url,
    });
  };

  //Opravné metody pro podsvícení u FP a FZ
  normalizePath = (path = "") => {
    if (!path) return "";
    if (path === "/") return "/";

    return path.replace(/\/+$/, "");
  };

  isActive = (item) => {
    const currentPath = this.normalizePath(window.location.pathname);

    if (item.filterBase) {
      const filterBase = this.normalizePath(item.filterBase);

      return (
        currentPath === filterBase ||
        currentPath.startsWith(filterBase + "/")
      );
    }

    if (item.navLink) {
      const navLink = this.normalizePath(item.navLink);

      return (
        currentPath === navLink ||
        currentPath.startsWith(navLink + "/")
      );
    }

    if (Array.isArray(item.parentOf)) {
      return item.parentOf.some((path) => {
        const parentPath = this.normalizePath(path);

        return (
          currentPath === parentPath ||
          currentPath.startsWith(parentPath + "/")
        );
      });
    }

    return false;
  };


  componentDidUpdate(prevProps, prevState) {
    if (prevProps.activePath !== this.props.activePath) {
      if (this.childObj.navLink && this.childObj.collapsed) {
        this.props.collapsedMenuPaths(this.childObj.navLink);
      }

      if (
        this.props.activeItemState === this.childObj.navLink &&
        !this.props.parentArr.includes(this.parentArray[0]) &&
        (this.childObj.filterBase
          ? window.location.pathname.includes(this.childObj.filterBase)
          : true)
      ) {
        this.props.parentArr.splice(0, this.props.parentArr.length);
        this.props.parentArr.push(this.parentArray);
      } else if (this.props.parentArr.includes(this.parentArray)) {
        this.props.parentArr.splice(0, this.props.parentArr.length);
      }
    }
  }

  renderChild(item, activeGroup, handleGroupClick, handleActiveItem) {
    return (
      <ul className="menu-content">
        {item.children
          ? item.children.map((child) => {
              const isNode = isItemTypeOfNode(child);
              const isLeaf = !isNode;
              const CustomAnchorTag =
                child.type === "external-link" ? `a` : Link;

              if (!this.parentArray.includes(item.id) && this.flag) {
                this.parentArray.push(item.id);
              }

              if (child.navlink && child.collapsed) {
                this.props.collapsedMenuPaths(child.navLink);
              }

              if (
                this.props.activeItemState === child.navLink &&
                (child.filterBase
                  ? window.location.pathname.includes(child.filterBase)
                  : true)
              ) {
                this.childObj = child;
                this.props.parentArr.push(this.parentArray);
                this.flag = false;
              }
              if (
                (!child.onlyPrague ||
                  (child.onlyPrague && this.props.isPrague)) &&
                ((child.permissions &&
                  (child.permissions.includes(this.props.currentUser) ||
                    (this.props.currentUserRoles &&
                      child.permissions.some((r) =>
                        this.props.currentUserRoles.includes(r)
                      )))) ||
                  child.permissions === undefined)
              ) {
                return (
                  <li
                    key={child.id}
                    className={classnames({
                      hover: this.props.hoverIndex === child.id,
                      "has-sub": isNode,
                      open: isNode && activeGroup.includes(child.id),
                      "sidebar-group-active":
                        this.props.currentActiveGroup.includes(child.id),
                      active:
                        (isLeaf && this.isActive(child)) ||
                        (Array.isArray(item.parentOf) &&
                          item.parentOf.some((path) =>
                            this.normalizePath(
                              this.props.activePath || window.location.pathname
                            ).startsWith(this.normalizePath(path))
                          )),
                      disabled: child.disabled,
                    })}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleGroupClick(child, item.id);
                      if (child.navLink && child.navLink !== undefined) {
                        handleActiveItem(child.navLink);
                      }
                      if (this.props.deviceWidth <= 1200 && isLeaf) {
                        this.props.toggleMenu();
                      }
                    }}
                  >
                    <CustomAnchorTag
                      className={classnames({
                        "d-flex justify-content-between": isNode,
                      })}
                      to={
                        child.filterBase
                          ? child.filterBase
                          : child.navLink && isLeaf
                            ? child.navLink
                            : ""
                      }
                      href={child.type === "external-link" ? child.navLink : ""}
                      onMouseEnter={() => {
                        this.props.handleSidebarMouseEnter(child.id);
                      }}
                      onMouseLeave={() => {
                        this.props.handleSidebarMouseEnter(child.id);
                      }}
                      key={child.id}
                      onClick={(e) => {
                        return isNode ? e.preventDefault() : "";
                      }}
                      target={child.newTab ? "_blank" : undefined}
                    >
                      <div className="menu-text">
                        {child.icon}
                        <span className="menu-item menu-title">
                          {child.title}
                        </span>
                      </div>
                      {child.badge ? (
                        <Badge
                          color={child.badge}
                          className="float-right mr-2"
                          pill
                        >
                          {child.badgeText}
                        </Badge>
                      ) : (
                        ""
                      )}
                      {isNode ? (
                        <ChevronRight className="menu-toggle-icon" size={13} />
                      ) : (
                        ""
                      )}
                    </CustomAnchorTag>

                    {child.children
                      ? this.renderChild(
                          child,
                          activeGroup,
                          handleGroupClick,
                          handleActiveItem,
                          item.id
                        )
                      : ""}
                  </li>
                );
              } else if (
                (!child.onlyPrague ||
                  (child.onlyPrague && this.props.isPrague)) &&
                child.navLink === this.props.activePath &&
                (!child.permissions.includes(this.props.currentUser) ||
                  (this.props.currentUserRoles &&
                    !child.permissions.some((r) =>
                      this.props.currentUserRoles.includes(r)
                    )))
              ) {
                return this.props.redirectUnauthorized();
              } else {
                return null;
              }
            })
          : null}
      </ul>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderChild(
          this.props.group,
          this.props.activeGroup,
          this.props.handleGroupClick,
          this.props.handleActiveItem,
          null
        )}
      </React.Fragment>
    );
  }
}
export default SideMenuGroup;
